export const LAST_BUILD_TIME = '2024-09-05T16:59:43.531Z'